import { createClient } from '@sanity/client';
import { mgPrisConfig } from '@retail/mgpris/config';

const { sanity } = mgPrisConfig;

export const sanityClient = createClient({
  projectId: sanity.projectId,
  dataset: sanity.dataset,
  useCdn: sanity.useCdn,
  apiVersion: sanity.apiVersion,
});
